import PropTypes from 'prop-types';
import React from 'react';

import { registerBenefitsClick } from 'ggApp/modules/gaAnalytics/actions';

import {
    Container,
    Background,
    ContentWrap,
    Icon,
    TextWrap,
    Header,
    Description,
    CloseButton,
    CloseIcon,
} from './styles';

const ExpandedItem = ({
    className,
    itemData: { title, description, image: { url } = {} },
    closeOverlay,
}) => {
    const handleClick = () => {
        closeOverlay();
        registerBenefitsClick(title, 'exit');
    };
    return (
        <Container className={className}>
            <Background />
            <ContentWrap>
                <Icon src={url} />
                <TextWrap>
                    <Header color="#17CCA8">{title}</Header>
                    <Description>{description}</Description>
                </TextWrap>
            </ContentWrap>
            <CloseButton onClick={handleClick}>
                <CloseIcon color="#17CCA8" />
            </CloseButton>
        </Container>
    );
};

ExpandedItem.propTypes = {
    className: PropTypes.string,
    itemData: PropTypes.shape({
        icon: PropTypes.object,
        title: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.shape({
            url: PropTypes.string,
        }),
    }),
    closeOverlay: PropTypes.func,
};

ExpandedItem.defaultProps = {
    className: '',
    itemData: {},
    closeOverlay: () => {},
};

export default ExpandedItem;
